exports.install = function (Vue, options) {
  Vue.prototype.$jumpTo = function (index) {
    this.$router.push(index)
  }
}
